import React from 'react'
import { connect } from 'react-redux'
import NotificationService, { dispatchNotification } from './NotificationService';
import { LanguageService } from '../../../services/LanguageService';
import Utils from '../../../services/Utils';
import { Browser } from '../../../services/helpers/Browser';
const DefaultSlowInetText = "We've detected poor internet connection that might affect your gaming experience. Please check your connection";

/**
 * Enum for notification type values.
 * @readonly
 * @enum {number}
 */
export const NotificationType = {
    /** Success Notification type */
    Success: 1,
    /** Error Notification type */
    Error: 2,
    /** Warning Notification type */
    Warning: 3,
    /** Close Notification */
    Close: 4,
    /** Slow Inet Notification type */
    SlowInet: 5,
    /** Go online Notification type */
    Online: 6
}

class Notification extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            show: props.show,
        }
    }

    componentDidMount() {
        this.slowConnectionHandler()

    }

    /** Slow Internet Connection handler 
     * @function
     * @memberOf Notification
     */
    slowConnectionHandler = () => {
        let connection = window.navigator.connection || navigator.mozConnection || navigator.webkitConnection;
        if (connection) {
            const handleConnectionChange = () => {
                if (connection.downlink <= 0.4 && connection.downlink !== 0) {
                    NotificationService.close(null, NotificationType.SlowInet)
                    this.props.dispatch(dispatchNotification(NotificationType.SlowInet, '', Utils.generateUUID()))
                } else {
                    NotificationService.close(null, NotificationType.SlowInet)
                }
            };
            handleConnectionChange();
            connection.removeEventListener("change", handleConnectionChange);
            connection.addEventListener("change", handleConnectionChange);
        }
    }

    /** This function fires on X(close) button click
     * @function
     * @memberOf Notification
     */
    onClose = (id, type) => {
        NotificationService.close(id, type);
    }

    /**
     * render
     * @return {ReactElement} markup
     */
    render() {
        const { notifications, translations } = this.props;
        const { isLoading = true } = translations;
        const { notificationsList } = notifications;
        const notificationsMap = () => {
            return notificationsList.map(notification => {
                switch (notification.type) {
                    case NotificationType.Success:
                        return <div className='tb--notice-container move-up-leave' key={notification.id}>
                            <div className='tb--notice-content tb--notice-success tb--flex tb--justify-between tb--align-center'>
                                <div className='tb--flex tb--align-center'>
                                    <i className='digi_icon-check tb--f-20'></i>
                                    <span className='tb--notice-msg'>{notification.message}</span>
                                </div>
                                <div className='tb--f-18'>
                                    <i onClick={this.onClose.bind(this, notification.id)} className='digi_icon-close tb--cp'></i>
                                </div>
                            </div>
                        </div>
                    case NotificationType.Error:
                        return <div className='tb--notice-container move-up-leave' key={notification.id}>
                            <div className='tb--notice-content tb--notice-error tb--flex tb--justify-between tb--align-center'>
                                <div className='tb--notice-error_sub tb--flex tb--align-center'>
                                    <i className='digi_icon-close tb--f-20'></i>
                                    <span className='tb--ph-8'>{notification.message}</span>
                                </div>
                                <div className='tb--f-18'>
                                    <i onClick={this.onClose.bind(this, notification.id)} className='digi_icon-close tb--cp'></i>
                                </div>
                            </div>
                        </div>
                    case NotificationType.Warning:
                        return <div className='tb--notice-container move-up-leave' key={notification.id}>
                            <div className='tb--notice-content tb--notice-warning tb--flex tb--justify-between tb--align-center'>
                                <div className='tb--flex tb--align-center'>
                                    <i className='digi_icon-exclamation tb--f-20'></i>
                                    <span className='tb--ph-8'>{notification.message}</span>
                                </div>
                                <div className='tb--f-18'>
                                    <i onClick={this.onClose.bind(this, notification.id)} className='digi_icon-close tb--cp'></i>
                                </div>
                            </div>
                        </div>
                    case NotificationType.SlowInet:
                        return <div className='tb--notice-container move-up-leave' key={notification.id}>
                            <div className='tb--notice-content tb--notice-network_poor tb--flex tb--justify-between tb--align-center'>
                                <div className='tb--flex tb--align-center'>
                                    <i className='digi_icon-poor_internet tb--f-20'></i>
                                    <span className='tb--notice-msg'>{isLoading ? DefaultSlowInetText : LanguageService.getTranslation('poorInternetConnectionText')}</span>
                                </div>
                                <div className='tb--f-18'>
                                    <i onClick={this.onClose.bind(this, notification.id)} className='digi_icon-close tb--cp'></i>
                                </div>
                            </div>
                        </div>
                    case NotificationType.Online:
                        return <div className='tb--notice-container move-up-leave' key={notification.id}>
                            <div className='tb--notice-content tb--notice-network_online tb--flex tb--justify-between tb--align-center'>
                                <div className='tb--flex tb--align-center'>
                                    <i className='digi_icon-wifi_on tb--f-20'></i>
                                    <span className='tb--notice-msg'>{LanguageService.getTranslation('internetOnText')}</span>
                                </div>
                                <div className='tb--f-18'>
                                    <i onClick={this.onClose.bind(this, null, NotificationType.Online)} className='digi_icon-close tb--cp'></i>
                                </div>
                            </div>
                        </div>
                    default:
                        return <></>
                }
            })
        }
        return (
            <div className={`tb--notice-wrapper${Browser.isMobNativeApp() ? ' mobile-app-notice' : ''}`}>
                {notificationsMap()}
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        notifications: state.notifications,
        translations: state.translations
    };
};
const mapDispatchToProps = (dispatch, props) => {
    return ({
        dispatch,
        props
    });
};
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Notification);
